import * as Types from '../Constants/AllConstants';

// ==================== TEAM REDUCERS ====================

// Get all teams
export const GetAllTeamsReducer = (
  state = { teams: [], pages: 0, page: 0 },
  action
) => {
  switch (action.type) {
    case Types.TEAM_LIST_REQUEST:
      return { ...state, loading: true };
    case Types.TEAM_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        teams: action.payload.content,
        pages: action.payload.totalPages,
        page: action.payload.number,
      };
    case Types.TEAM_LIST_FAIL:
      return { loading: false, error: action.payload };
    case Types.TEAM_LIST_RESET:
      return { teams: [] };
    default:
      return state;
  }
};

// Team details
export const TeamDetailsReducer = (state = { team: {} }, action) => {
  switch (action.type) {
    case Types.TEAM_DETAILS_REQUEST:
      return { loading: true };
    case Types.TEAM_DETAILS_SUCCESS:
      return { loading: false, team: action.payload };
    case Types.TEAM_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// Create team
export const CreateTeamReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.TEAM_CREATE_REQUEST:
      return { loading: true };
    case Types.TEAM_CREATE_SUCCESS:
      return { loading: false, success: true, team: action.payload };
    case Types.TEAM_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case Types.TEAM_CREATE_RESET:
      return {};
    default:
      return state;
  }
};

// Update team
export const UpdateTeamReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.TEAM_UPDATE_REQUEST:
      return { loading: true };
    case Types.TEAM_UPDATE_SUCCESS:
      return { loading: false, success: true, team: action.payload };
    case Types.TEAM_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case Types.TEAM_UPDATE_RESET:
      return {};
    default:
      return state;
  }
};

// Delete team
export const DeleteTeamReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.TEAM_DELETE_REQUEST:
      return { loading: true };
    case Types.TEAM_DELETE_SUCCESS:
      return { loading: false, success: true };
    case Types.TEAM_DELETE_FAIL:
      return { loading: false, error: action.payload };
    case Types.TEAM_DELETE_RESET:
      return {};
    default:
      return state;
  }
};